var CustomFieldLocaleDataBuilder = /** @class */ (function () {
    function CustomFieldLocaleDataBuilder() {
        this.customFieldLocaleData = {
            title: 'My Cool Field',
            translatedTitles: {},
            placeHolder: 'Enter something',
            description: 'This is a field for something',
            values: [],
            disabled: false
        };
    }
    CustomFieldLocaleDataBuilder.prototype.withTitle = function (title) {
        this.customFieldLocaleData.title = title;
        return this;
    };
    CustomFieldLocaleDataBuilder.prototype.withPlaceholder = function (placeholder) {
        this.customFieldLocaleData.placeHolder = placeholder;
        return this;
    };
    CustomFieldLocaleDataBuilder.prototype.withDescription = function (description) {
        this.customFieldLocaleData.description = description;
        return this;
    };
    CustomFieldLocaleDataBuilder.prototype.withValues = function (values) {
        this.customFieldLocaleData.values = values;
        return this;
    };
    CustomFieldLocaleDataBuilder.prototype.withDisabled = function (val) {
        this.customFieldLocaleData.disabled = val;
        return this;
    };
    CustomFieldLocaleDataBuilder.prototype.build = function () {
        return this.customFieldLocaleData;
    };
    return CustomFieldLocaleDataBuilder;
}());
export { CustomFieldLocaleDataBuilder };
;
//# sourceMappingURL=custom-field-locale-data.builder.js.map